import React, {
  useState,
} from "react";

import {
  ShieldCheck,
  FileText,
  Mail,
  Phone,
  MapPin,
  Send,
  X,
  CheckCircle2,
  AlertTriangle,
  ChevronDown,
  ChevronUp,
} from "lucide-react";

import { toast }
from "react-toastify";

import "./PolicyRenewalModal.css";

import BrokerAppointmentForm
from "./BrokerAppointmentForm";

const PolicyRenewalModal = ({
  onClose,
}) => {

  const [formData,
    setFormData] =
      useState({
        full_name: "",
        contact_email: "",
        contact_number: "",
        contact_address: "",
      });

  const [uploadedFiles,
    setUploadedFiles] =
      useState([]);

  const [brokerDocUrl,
    setBrokerDocUrl] =
      useState("");

  const [isSubmitting,
    setIsSubmitting] =
      useState(false);

  const [showBrokerForm,
    setShowBrokerForm] =
      useState(false);

  const [status,
    setStatus] =
      useState("");

  const handleFileChange =
    (e) => {

    const files =
      Array.from(e.target.files);

    setUploadedFiles(files);
  };

const handleSubmit =
  async (e) => {

    e.preventDefault();

    if (!brokerDocUrl) {

      toast.warn(
"📄 Please finish the Broker Appointment form first."
      );

      return;
    }

    try {

      setIsSubmitting(true);

      const data =
        new FormData();

      Object.entries(formData)
        .forEach(([key, value]) => {

          data.append(
            key,
            value
          );
        });

      uploadedFiles.forEach(
        (file) => {

          data.append(
            "files",
            file
          );
        });

      data.append(
        "brokerDocUrl",
        brokerDocUrl
      );

      const res =
        await fetch(
"https://rcsbackend.onrender.com/send-policy-renewal",
{
  method: "POST",
  body: data,
}
      );

      const result =
        await res.json();

      setIsSubmitting(false);

      // =========================
      // SUCCESS
      // =========================

      if (result.success) {

        setStatus("success");

        setFormData({
          full_name: "",
          contact_email: "",
          contact_number: "",
          contact_address: "",
        });

        setUploadedFiles([]);

        setBrokerDocUrl("");

        // CLOSE AFTER DELAY
        setTimeout(() => {

          onClose();

        }, 3500);

      } else {

        // =========================
        // FAILURE
        // =========================

        setStatus("failure");

        setTimeout(() => {

          setStatus("");

        }, 5000);
      }

    } catch (err) {

      console.error(err);

      setIsSubmitting(false);

      setStatus("failure");

      setTimeout(() => {

        setStatus("");

      }, 5000);
    }
  };

  return (

    <div className="modern-policy-overlay">

      <div className="modern-policy-modal">

        {/* CLOSE */}

        <button
          className="modern-policy-close"
          onClick={onClose}
        >
          <X size={22} />
        </button>

        {/* HEADER */}

        <div className="modern-policy-header">

          <div className="modern-policy-icon">

            <ShieldCheck size={34} />

          </div>

          <div>

            <h2>
              Policy Renewal Request
            </h2>

            <p>
              Submit your insurance
              renewal request quickly
              and securely.
            </p>

          </div>

        </div>

        {/* FORM */}

        <form
          onSubmit={handleSubmit}
          className="modern-policy-form"
        >

          <div className="modern-policy-grid">

            <div className="modern-policy-group">

              <label>
                Full Name
              </label>

              <div className="modern-policy-input">

                <FileText size={18} />

                <input
                  type="text"
                  placeholder="Enter full name"
                  value={
                    formData.full_name
                  }
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      full_name:
                        e.target.value,
                    })
                  }
                  required
                />

              </div>

            </div>

            <div className="modern-policy-group">

              <label>
                Contact Number
              </label>

              <div className="modern-policy-input">

                <Phone size={18} />

                <input
                  type="tel"
                  placeholder="Enter contact number"
                  value={
                    formData.contact_number
                  }
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      contact_number:
                        e.target.value,
                    })
                  }
                  required
                />

              </div>

            </div>

          </div>

          <div className="modern-policy-group">

            <label>
              Email Address
            </label>

            <div className="modern-policy-input">

              <Mail size={18} />

              <input
                type="email"
                placeholder="Enter email"
                value={
                  formData.contact_email
                }
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    contact_email:
                      e.target.value,
                  })
                }
                required
              />

            </div>

          </div>

          <div className="modern-policy-group">

            <label>
              Address
            </label>

            <div className="modern-policy-input">

              <MapPin size={18} />

              <input
                type="text"
                placeholder="Enter address"
                value={
                  formData.contact_address
                }
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    contact_address:
                      e.target.value,
                  })
                }
                required
              />

            </div>

          </div>

          {/* UPLOAD */}

          <div className="modern-policy-group">

            <label>
              Upload Documents
            </label>

            <label className="modern-policy-upload">

              <FileText size={26} />

              <span>
                Upload Current Policy,
                ID or Supporting Documents
              </span>

              <input
                type="file"
                accept="image/*,.pdf"
                multiple
                onChange={
                  handleFileChange
                }
              />

            </label>

          </div>

          {/* FILES */}

          {uploadedFiles.length >
            0 && (

            <div className="modern-policy-files">

              {uploadedFiles.map(
                (file, i) => (

                <div
                  className="modern-policy-file"
                  key={i}
                >

                  <FileText size={16} />

                  {file.name}

                </div>
              ))}

            </div>
          )}

          {/* BROKER FORM */}

          <button
            type="button"
            className="modern-broker-toggle"
            onClick={() =>
              setShowBrokerForm(
                !showBrokerForm
              )
            }
          >

            {showBrokerForm ? (
              <>
                <ChevronUp size={18} />
                Hide Broker Appointment Form
              </>
            ) : (
              <>
                <ChevronDown size={18} />
                Fill Broker Appointment Form
              </>
            )}

          </button>

          {showBrokerForm && (

            <BrokerAppointmentForm
              fullName={
                formData.full_name
              }

              address={
                formData.contact_address
              }

              onFinish={(file) => {

                toast.success(
"📄 Broker form attached!"
);

                setBrokerDocUrl(
                  file
                );
              }}
            />
          )}

          {/* BUTTONS */}

          <div className="modern-policy-actions">

            <button
              type="submit"
              className="modern-policy-submit"
              disabled={isSubmitting}
            >

              {isSubmitting ? (
                <>
                  <Send size={18} />
                  Submitting...
                </>
              ) : (
                <>
                  <Send size={18} />
                  Submit Renewal
                </>
              )}

            </button>

            <button
              type="button"
              className="modern-policy-cancel"
              onClick={onClose}
            >
              Cancel
            </button>

          </div>

        </form>

        {/* STATUS */}

        {status && (

          <div
            className={`modern-policy-status ${
              status
            }`}
          >

            {status ===
            "success" ? (
              <>
                <CheckCircle2
                  size={72}
                />

                <h3>
                  Renewal Request Sent!
                </h3>

                <p>
                  Our team will
                  contact you shortly.
                </p>
              </>
            ) : (
              <>
                <AlertTriangle
                  size={72}
                />

                <h3>
                  Submission Failed
                </h3>

                <p>
                  Please try again later.
                </p>
              </>
            )}

          </div>
        )}

      </div>

    </div>
  );
};

export default PolicyRenewalModal;